/*
 * @Description: 为了的是解决一些客户端的坑， 这里单独维护
 * @Author: kadenwang@tencent.com
 * @Date: 2020-07-22 10:47:26
 * @LastEditors: kadenwang@tencent.com
 * @LastEditTime: 2020-07-22 10:59:08
 */

export const GetInstalledListHackMap = {
  'com.tencent.kihan': 'com.tencent.KiHan',
  'com.tencent.yiren': 'com.tencent.YiRen',
};
